import type {
  StaticApplicationsFooterBffNewsletterFooterDto,
  StaticApplicationsFooterBffPopupDto,
} from '@ori/static-api-client-react';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

import {
  newsletterSubscribeCookieKey,
  newsletterSubscribeCookieValue,
  newsletterPopupCookieKey,
  newsletterPopupCookieValue,
} from '../constants';
import { isCookieSet } from '../utils';

export interface UseSubscribePopupParams {
  open: boolean;
  onOpen: () => void;
  footer: StaticApplicationsFooterBffNewsletterFooterDto | undefined;
  popup: StaticApplicationsFooterBffPopupDto | undefined;
}
export const useSubscribePopup = ({ open, onOpen, footer, popup }: UseSubscribePopupParams) => {
  useEffect(() => {
    // Return early if newsletter or popup is not enabled
    if (!footer?.enabled || !popup?.enabled) {
      return;
    }

    const popupDelay = popup.delayInSeconds;
    // Return early if time is not set
    if (!popupDelay || popupDelay < 1) {
      return;
    }

    // Return early if person is already subscribed or the popup was opened before
    if (
      isCookieSet(newsletterSubscribeCookieKey, newsletterSubscribeCookieValue) ||
      (!open && isCookieSet(newsletterPopupCookieKey, newsletterPopupCookieValue))
    ) {
      return;
    }

    // Set up delayed popup and set cookie that will expire in number of days set in Sitecore
    const timer = setTimeout(() => {
      Cookies.set(newsletterPopupCookieKey, newsletterPopupCookieValue, {
        expires: popup.displayFrequencyInDays,
      });
      onOpen();
    }, popupDelay * 1000);

    // If dialog is open we do not need delayed opening
    if (open) {
      clearTimeout(timer);
    }

    // eslint-disable-next-line consistent-return -- cleanup function
    return () => clearTimeout(timer);
  }, [open, footer, popup, onOpen]);
};
